// @flow
import styled from "styled-components";

export const WidgetSpacer = styled.div`
	width: 100%;
	height: 10px;
`;

export default WidgetSpacer;